interface OpenWindowInterface {
    link?: string | null;
    height?: number;
    width?: number;
}

export const openWindow = ({ link, height = 600, width = 800 }: OpenWindowInterface) => {
    if (link) window.open(`${link}&hidelaunch=true`, '_blank', `width=${width},height=${height}`);
};
